import { jsx as _jsx } from "react/jsx-runtime";
const icons = {
  plus: 'https://focus.mediahuisgroup.com/raw/prod-mh-aboshop/aboshop-mhbe/public/2tobkzq1.pqo.svg',
  plusBlack: 'https://focus.mediahuisgroup.com/raw/prod-mh-aboshop/aboshop-mhbe/public/phrfjgic.h5c.svg',
  routeYouLogo: 'https://focus.mediahuisgroup.com/raw/prod-mh-aboshop/aboshop-mhbe/public/t0gwz5yo.x54.svg'
};
const RouteYouIcon = _ref => {
  let {
    height,
    icon,
    width
  } = _ref;
  return /*#__PURE__*/_jsx("img", {
    src: icons[icon],
    height: height,
    width: width
  });
};
export default RouteYouIcon;